import SelectedIcon from "../../components/miscellaneous/selected-icon";
import getUniqueId from "../../utils/getUniqueId";
import AmpleHireLabelTag from "../ample-hire-html-tags/ample-hire-label-tag";
import AmpleHireSelectTag from "../ample-hire-html-tags/ample-hire-select-tag";

const GridselectInputField = ({
  divTagCssClasses = "",
  selectTagCssClasses = "",
  optionTagClasses = "",
  selectTagIdAndName = "",
  options,
  value,
  onChange,
  multiple = false,
  disabled = false,
  required = false,
  selectedValues = [],
  setSelectedValues = () => {},
  handleRemoveSelectedValue = () => {},
  labelText,
  labelIconSrc = null,
  labelIconAltText = "",
  labelIconCss = "",
  ...props
}) => {
  return (
    <>
      <AmpleHireSelectTag
        className={selectTagCssClasses}
        optionTagClassName={optionTagClasses}
        id={selectTagIdAndName}
        name={selectTagIdAndName}
        options={options}
        value={value}
        onChange={onChange}
        multiple={multiple}
        disabled={disabled}
        {...props}
      />
      <AmpleHireLabelTag
        htmlFor={selectTagIdAndName}
        labelText={labelText}
        required={required}
        labelIconSrc={labelIconSrc}
        labelIconCss={labelIconCss}
        labelIconAltText={labelIconAltText}
      />

      {multiple &&
        selectedValues?.map((value, index) => (
          <SelectedIcon
            key={getUniqueId()}
            selectedIconText={value}
            id={selectTagIdAndName}
            name={selectTagIdAndName}
            onClickIcon={() =>
              handleRemoveSelectedValue(value, selectTagIdAndName)
            }
          />
        ))}
    </>
  );
};

export default GridselectInputField;
